import { render, staticRenderFns } from "./EpiduralInjections.vue?vue&type=template&id=2a32a92a&scoped=true"
import script from "./EpiduralInjections.vue?vue&type=script&lang=js"
export * from "./EpiduralInjections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a32a92a",
  null
  
)

export default component.exports